<template>
    <hts-form
        :rules="defineRule"
        @submit="handleSubmit">
        <div
            v-loading="loading"
            class="flex flex-col gap-5">
            <h3>
                Cấu hình container
            </h3>

            <div class="overflow-auto">
                <table class="w-full min-w-[1024px] table-fixed border-collapse rounded-lg">
                    <thead>
                        <tr class="bg-gray-100">
                            <th class="p-3 border border-gray-300">
                                <p>
                                    {{ $t('labels.contType') }}
                                </p>
                            </th>
                            <th class="p-3 border border-gray-300">
                                <p>
                                    {{ $t('labels.weightShellContainerByKg') }}
                                </p>
                            </th>
                            <th class="p-3 border border-gray-300">
                                <p>
                                    {{ $t('labels.weightCommodityByKGMaximum') }}
                                </p>
                            </th>
                            <th class="p-3 border border-gray-300">
                                <p>
                                    {{ $t('labels.weightRemoocKG') }}
                                </p>
                            </th>
                            <th class="p-3 border border-gray-300">
                                <p>
                                    {{ $t('labels.totalWeightMaximumByKg') }}
                                </p>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in items"
                            :key="index"
                            class="hover:bg-gray-50">
                            <td class="p-3 border border-gray-300">
                                <span class="font-bold">
                                    {{ item.name }}
                                </span>
                            </td>
                            <td class="p-3 border border-gray-300">
                                <hts-form-input
                                    v-model="items[index].weightContainer"
                                    type="number"
                                    :prop="index + 'weightContainer'"
                                    :name="index + 'weightContainer'"
                                    @change="updateTotal(index)" />
                            </td>
                            <td class="p-3 border border-gray-300">
                                <hts-form-input
                                    v-model="items[index].weightCargo"
                                    type="number"
                                    :prop="index + 'weightCargo'"
                                    :name="index + 'weightCargo'"
                                    @change="updateTotal(index)" />
                            </td>
                            <td class="p-3 border border-gray-300">
                                <hts-form-input
                                    v-model="items[index].weightRemooc"
                                    type="number"
                                    :prop="index + 'weightRemooc'"
                                    :name="index + 'weightRemooc'"
                                    @change="updateTotal(index)" />
                            </td>
                            <td class="p-3 border border-gray-300">
                                <hts-form-input
                                    v-model="items[index].total"
                                    disabled
                                    type="number" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <hts-form-button
                    class="text-right"
                    icon-name="hi-clipboard-document-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
        </div>
    </hts-form>
</template>

<script setup lang="ts">
const loading = ref(false)
const towingCapacityList = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

const emits = defineEmits(['close', 'update'])

const store = $store()

const globalSettingsInformation = ref({} as { [key: string]: any })

onMounted(() => {
  nextTick(() => {
    _init()
  })
})

const items = ref<{ [key: string]: any }>({})

const _init = async () => {
  loading.value = true

  await getGlobalSettingsInformation()

  items.value = {}

  const contSetting = globalSettingsInformation.value?.configCont || {}

  towingCapacityList.forEach((item: { [key: string]: any }) => {
    const defineItem = {
      name: contSetting[item.value] ? contSetting[item.value].name : item.label,
      weightContainer: contSetting[item.value] ? contSetting[item.value].weightContainer : 0,
      weightCargo: contSetting[item.value] ? contSetting[item.value].weightCargo : 0,
      weightRemooc: contSetting[item.value] ? contSetting[item.value].weightRemooc : 0,
      total: contSetting[item.value] ? contSetting[item.value].total : 0
    }
    // Thay vì thay thế toàn bộ items.value, hãy cập nhật từng phần tử
    items.value[item.value] = defineItem
  })

  loading.value = false
}

const getGlobalSettingsInformation = async () => {
  const api = $urlClient.settings.getGlobalSettings
  await $api(api).then((data) => {
    if (!data) {
      return true
    }
    const responseData: any = data.data.value

    if (responseData.success) {
      globalSettingsInformation.value = responseData.data
    }
  })
}

const defineRule = computed(() => {
  const result: { [key: string]: any } = {}
  towingCapacityList.forEach((item: { [key: string]: any }, index: number) => {
    result[item.value + 'weightContainer'] = 'requiredAutoInput|numeric'
    result[item.value + 'weightCargo'] = 'requiredAutoInput|numeric'
    result[item.value + 'weightRemooc'] = 'requiredAutoInput|numeric'
  })
  return result
})

const updateTotal = (index: number | string) => {
  items.value[index].total = items.value[index].weightContainer + items.value[index].weightCargo + items.value[index].weightRemooc
}
const handleSubmit = () => {
  const api = $urlClient.settings.updateConfigContSettings
  $api(api, { body: { configCont: items.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        store.globalSettings.setGlobalSettings(responseData.data)
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}
</script>
